import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FD100KitPage from './FD100KitPage';

const PresseKitView = () => {
    const [searchParams] = useSearchParams();
    const lang = searchParams.get('lang');

    return (
        <FD100KitPage
            mode="presse"
            displayName="Le FRENCH DESIGN 100"
            displayLogo="/assets/fd100-kit/logos/SD25-FD100-Logo-Story.png"
        />
    );
};

export default PresseKitView;
